// extracted by mini-css-extract-plugin
export default {"search_bar":"index_search_bar_4GLit"};